import Vue from 'vue'
import Vuex from 'vuex'
import zh from '../../../i18n/zh-cn.toml'
import en from '../../../i18n/en-us.toml'
import fr from '../../../i18n/fr-fr.toml'
import ko from '../../../i18n/ko-kr.toml'

import { EventBus } from './event-bus';
Vue.use(Vuex)
var config;
const lang = localStorage.getItem('system.lang') || 'zh-cn';
switch (lang) {
  case 'zh-cn':
    config = zh;
    break;
  case 'en-us':
    config = en;
    break;
  case 'fr-fr':
    config = fr;
    break;
  case 'ko-kr':
    config = ko;
    break;
  default:
    config = zh;
    break;
}

export default new Vuex.Store({
  state: {
    breadcrumbItems: [], // 默认空数组
    warnListData:{},//告警
    lang: config, // 默认使用本地语言配置
    prodSpotRefresh:[], //焊点管理是否已刷新
    queryDate:[new Date(),new Date()],
  },
  mutations: {
    setBreadcrumbItems(state, items) {
      state.breadcrumbItems = items
    },
    setWarnList(state, items) {
      state.warnListData = items
    },
    setLang(state, langData) {
      state.lang = langData
      // 同时更新全局变量，保持兼容性
      Vue.prototype.$lang = langData
    },
    setProdSpotRefresh(state, val) {
      state.prodSpotRefresh = val
    },
    setQueryDate(state, val) {
      state.queryDate = val
    },
  },
  actions: {
    // 更新语言数据
    updateLang({ commit }, langData) {
      commit('setLang', langData)
    },

    // 从服务器获取语言数据
    async fetchLang({ commit }) {
      try {       
          EventBus.$emit('lang-finish');         
      } catch (error) {
        console.error('Failed to fetch language data:', error)
        // 使用默认配置
        commit('setLang', config)
        return config
      }
    }
  },
  getters: {
    // 获取语言数据
    getLang: state => state.lang,

    // 获取特定键值的翻译
    getTranslation: state => key => {
      return state.lang[key] || key
    },
    getProdSpotRefresh:state => state.prodSpotRefresh,

    getQueryDate: state => state.queryDate,
  }
})